export enum Precision {
  FULL,
  HALF,
  TENTH,
  ONE_HUNDRETH,
  FIVE_HUNDRETH,
}

export namespace Precision {
  let elements = [
    Precision.FULL,
    Precision.HALF,
    Precision.TENTH,
    Precision.ONE_HUNDRETH,
    Precision.FIVE_HUNDRETH,
  ];
  let alias = "com.bcdfx.model.Precision";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
